import React, { Component } from 'react'
import PropTypes from 'prop-types'
import RadioGroup from './event_setup/radio_group'
import InputForm from './event_setup/input_form'

const HANDICAP_VALUE_REGEX = /^[+\-pP]?\d+([.,]\d+)?$|^[+\-pP]?[.,]\d+$/

function normalizeHandicapValue(val) {
  if (val === '' || val === null) return val
  return HANDICAP_VALUE_REGEX.test(val.trim()) ? val : ''
}

function GenderedHandicapIndex({label, value, setOption, parentObject}) {

  function completeForm(index, gender) {
    setOption[gender](index)
    parentObject.setState({dataChanged: true})
  }

  return (
    <div className='gendered_hi_container'>
      <label>{label}</label>
      <div className='mf_values_container'>
        <div>
          <label>M</label>
          <InputForm
                  id={`${label}_M`}
                  value={value['M'] || ''}
                  validate={normalizeHandicapValue}
                  onEditCompleted={(index) => index !== value['M'] && completeForm(index, 'M')}
                />
        </div>
        <div>
          <label>F</label>
          <InputForm
                  id={`${label}_F`}
                  value={value['F'] || ''}
                  validate={normalizeHandicapValue}
                  onEditCompleted={(index) => index !== value['F'] && completeForm(index, 'F')}
                />
        </div>
      </div>
    </div>
  )
}

GenderedHandicapIndex.propTypes = {
  label: PropTypes.string,
  value: PropTypes.object,
  setOption: PropTypes.object,
  parentObject: PropTypes.object,
}

class EventSetupHandicaps extends Component {
  constructor(props){
    super(props)
    this.state = {
      dataChanged: false,
    }
  }

  componentDidUpdate(prevProps) {
    if ((this.props.content.data !== prevProps.content.data && this.props.content.dataChanged) || this.state.dataChanged) {
      this.props.save()
      this.setState({dataChanged: false})
    }
  }


  render() {
    const { title, data } = this.props.content
    const setter = (keys) => (value) => this.props.setData([ 'data' ].concat(keys), value)

    return (
      <div className='widget-content-default widget-event-setup-handicaps'>
        <div className='title'>
          { title }
        </div>

        <div className='content flex-list-layout'>
          <ul>
            <li key='card_type'>
              <RadioGroup
                id='card_type'
                {...data['card_type']}
                setOption={ setter([ 'card_type', 'selected' ])}
                vertical={true}
              />
            </li>

            <li key='maximum_handicap_indexes_title'>
              <label>{data['maximum_handicap_indexes']['title']}</label>
              <br />
            </li>

            <li key='maximum_handicap_index_18_hole'>
              <GenderedHandicapIndex
                {...data['maximum_handicap_indexes']['eighteen_hole']['handicap_index']}
                setOption={{
                  'M': setter([ 'maximum_handicap_indexes', 'eighteen_hole', 'handicap_index', 'value', 'M' ]),
                  'F': setter([ 'maximum_handicap_indexes', 'eighteen_hole', 'handicap_index', 'value', 'F' ]),
                }}
                parentObject={this}
              />
            </li>
            <li key='maximum_course_index_18_hole'>
              <GenderedHandicapIndex
                {...data['maximum_handicap_indexes']['eighteen_hole']['course_handicap']}
                setOption={{
                  'M': setter([ 'maximum_handicap_indexes', 'eighteen_hole', 'course_handicap', 'value', 'M' ]),
                  'F': setter([ 'maximum_handicap_indexes', 'eighteen_hole', 'course_handicap', 'value', 'F' ]),
                }}
                parentObject={this}
              />
            </li>

            {
              data['card_type'].selected === '9 hole' &&
                <>
                  <li key='maximum_handicap_index_9_hole'>
                    <GenderedHandicapIndex
                      {...data['maximum_handicap_indexes']['nine_hole']['handicap_index']}
                      setOption={{
                        'M': setter([ 'maximum_handicap_indexes', 'nine_hole', 'handicap_index', 'value', 'M' ]),
                        'F': setter([ 'maximum_handicap_indexes', 'nine_hole', 'handicap_index', 'value', 'F' ]),
                      }}
                      parentObject={this}
                    />
                  </li>
                  <li key='maximum_course_index_9_hole'>
                    <GenderedHandicapIndex
                      {...data['maximum_handicap_indexes']['nine_hole']['course_handicap']}
                      setOption={{
                        'M': setter([ 'maximum_handicap_indexes', 'nine_hole', 'course_handicap', 'value', 'M' ]),
                        'F': setter([ 'maximum_handicap_indexes', 'nine_hole', 'course_handicap', 'value', 'F' ]),
                      }}
                      parentObject={this}
                    />
                  </li>
                </>
            }

            <br/>
            <li key='allocate_by_subset'>
              <RadioGroup
                id='allocate_by_subset'
                {...data['allocate_by_subset']}
                setOption={ setter([ 'allocate_by_subset', 'selected' ])}
                vertical={true}
              />
            </li>

          </ul>
        </div>

      </div>
    )
  }
}

EventSetupHandicaps.propTypes = {
  content: PropTypes.object,
  setData: PropTypes.func,
  save: PropTypes.func,
}

EventSetupHandicaps.defaultProps = {
  content: {
    title: 'HANDICAPS',
    data: {},
  },
}

export default EventSetupHandicaps
